/*
 * File: EmailAgreements.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on April 20, 2025 at 11:54 PM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: April 25, 2025 at 2:42 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';

// Components
import { LegalSnippet as LegalSnippetBase } from '../../LegalSnippet';

// Constants
import { ShareBottomPadding, ShareTopbarHeight } from '../../../styles/constants';


/**
 * Styles
 */

export const StepContainer = styled.div`
	width: 100%;
	min-height: calc(100vh - ${ShareTopbarHeight}px - ${ShareBottomPadding}px);
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const InnerStep = styled.div`
	width: 100%;
	max-width: 700px;
	padding: 50px 0px 50px;
`;

export const ContentContainer = styled.div`
	p {
		margin: 10px 0px 0px;
	}
	br {
		margin: 10px;
	}
`;

export const ActionContainer = styled.div`
	margin: 30px 0px 0px;
	display: flex;
	gap: 10px;
`;

export const LegalSnippet = styled(LegalSnippetBase)`
	margin: 30px 0px 0px;
`;

export const InputContainer = styled.div`
	margin: 30px 0px 40px;

	input[type=text] {
		height: 55px;
		max-width: 500px;
	}
`;

export const AgreementsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 23px;
	margin: 30px 0px 0px;
`;

export const AgreementRow = styled.div`
	display: flex;
	gap: 12px;
`;

export const AgreementContent = styled.div``;

export const RequiredBadge = styled.span`
	padding: 3px 12px 3px;
    border-radius: 30px;
    top: -2px;
    position: relative;
    margin-left: 6px;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 0.55rem;
	border: 1px solid ${({ theme }) => theme.primaryText};
`;
